/* eslint-disable no-undef */
import ajax from '../snippet/ajax';

const ajaxProjectPosts = () => {
  const $container = $('.js--salvattore-project-posts-container');

  if (!$container.length) {
    return;
  }

  const displayElementsCallback = (res) => {
    salvattore.appendElements($container[0], $.parseHTML(res));
  };

  const renderFilteredElementsCallback = (res) => {
    const content = $.parseHTML(res);
    $container.empty();
    $container.append(content);
    salvattore.rescanMediaQueries();
  };

  ajax('projekty', 'post', displayElementsCallback, renderFilteredElementsCallback);
};

export default ajaxProjectPosts;
